<template>
  <v-dialog v-model="dialog" max-width="400">
    <v-card class="shadow">
      <v-card-title class="text-h6 font-weight-regular">
        Filter
      </v-card-title>

      <v-card-text style="gap:1rem">
        <v-form ref="form" class="d-flex flex-column" style="gap: 1rem">
          <v-select v-model="status" outlined dense :items="statuses" label="Status" hide-details />

          <v-menu v-model="date_from_menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field :rules="[rules.required]" v-model="date_from" label="Date From" clearable readonly outlined
                dense hide-details="auto" v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="date_from" @input="date_from_menu = false"></v-date-picker>
          </v-menu>

          <v-menu v-model="date_to_menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="date_to" label="Date To (Optional)" clearable readonly outlined dense
                hide-details="auto" v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="date_to" :min="date_from" @input="date_to_menu = false"></v-date-picker>
          </v-menu>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <div class="d-flex justify-end" style="width: 100%; gap:.30rem">
          <v-btn text depressed color="grey" class="px-2" @click="close_dialog">
            Cancel
          </v-btn>

          <v-btn depressed color="primary" class="px-2" @click="set_filter">
            Filter
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import form_rules from '@/helpers/formRules'

export default {
  props: {
    data: {
      type: Object
    }
  },

  data: () => ({
    status: '',
    statuses: ['All', 'Requested', 'Verified', 'Approved'],
    rules: form_rules,
    date_from_menu: false,
    date_from: null,
    date_to_menu: false,
    date_to: null
  }),

  computed: {
    dialog: {
      get: function () {
        return true
      },
      set: function () {
        this.close_dialog()
      }
    }
  },

  mounted() {
    if (Object.keys(this.data).length) {
      this.date_from = this.data.date_from
      this.date_to = this.data.date_to
      this.status = this.data.status
    }
  },

  methods: {
    set_filter() {
      if (this.$refs.form.validate()) {
        this.$emit("set_close_special_commission_filter_dialog", {
          'date_from': this.date_from,
          'date_to': (this.date_to) ?? this.date_from,
          'status': this.status
        })
      }
    },

    close_dialog() {
      this.$emit("set_close_special_commission_filter_dialog", {})
    }
  }
}
</script>